/**
 * Environment URL constants
 * These read from EXPO_PUBLIC_* env vars which should be set per environment
 */

export const COMMUNITY_APP_URL =
  process.env.EXPO_PUBLIC_COMMUNITY_APP_URL || 'https://app.joincommuniful.com';

export const MANAGER_APP_URL =
  process.env.EXPO_PUBLIC_MANAGER_APP_URL ||
  'https://manager.joincommuniful.com';

export const SESSION_SHARE_URL =
  process.env.EXPO_PUBLIC_SESSION_SHARE_URL ||
  'https://share.joincommuniful.com';
